import { Component, OnInit, Inject } from '@angular/core';
import { ServiciosService } from '../../services/servicios.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { EquiposComponent } from 'app/components/servicio-medico/despacho/subdespacho/equipos/equipos.component';
import { NgSelectModule } from '@ng-select/ng-select';

@Component ({
  selector: 'app-agregar-medico',
  templateUrl: './agregar-medico.component.html',
  styleUrls: ['./agregar-medico.component.scss']
})
export class AgregarMedicoComponent implements OnInit {

  public medicos;
  public medico;

  constructor(  private servicios:ServiciosService,
                public dialogRef: MatDialogRef<EquiposComponent>,
                @Inject(MAT_DIALOG_DATA) private datos,
                private snack: MatSnackBar
             ) { }

  ngOnInit() {
    this.servicios.medicos().subscribe((data)=>{
        this.medicos = data;
        console.log(data);
    })
  }

  enviar(){
      if (this.medico == null || this.medico == undefined || this.medico == "" ) {
        this.snack.open('Elija un medico', '', {
            duration: 2000,
            panelClass: 'red-bg'
          })
      } else {
        this.servicios.agregarMedico(this.medico.Cod_Med, this.datos.movil).subscribe((data)=>{
            console.log(data);
        });
        this.dialogRef.close(this.medico.Medico);
      }
  }

}
